<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn icon small v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="item in items"
        :key="item.key"
        :disabled="item.disabled || busy"
        @click="select(item)"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
          <v-list-item-subtitle v-if="item.disabled && item.reason">{{ item.reason }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// The "..." menu of one grid row (an ag-Grid cell renderer). The grid passes
// the menu items, the busy flag and the click handler as renderer params.
export default {
  name: "CvcMigrationRowActions",
  computed: {
    items () {
      return this.params.items(this.params.data);
    },
    busy () {
      return this.params.busy();
    },
  },
  methods: {
    select (item) {
      this.params.onAction(item.key, this.params.data, item);
    },
  },
};
</script>
